export default {"src":"/_next/static/media/ic_layer_close.a6ba867d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};